import { FaApplePay } from 'react-icons/fa';
import React from 'react';
import classnames from 'classnames';
import pure from 'purecss/build/buttons-core-min.css';
import style from './style.scss';

const {
    colbyGiving: { applePayUrl },
} = window;

export default function ApplePay() {
    return (
        <a
            className={classnames({
                [pure['pure-button']]: true,
                [style.buttonGive]: true,
                [style.apple]: true,
                'colby-giving-plugin-buttons-apple-button': true,
            })}
            href={`${applePayUrl}`}
            target="_blank"
            rel="noreferrer noopener"
            aria-label="Apple Pay"
        >
            <FaApplePay size="3em" />
        </a>
    );
}
